<template>
    <div class="menu">
        <div class="block"
             v-for="(item, index) in menu.children"
             :key="index"
			 :class="{show:item.show}"
			 @click="item.show = !item.show"
			 >
            <div class="tit">
				{{ item.meta.name }}
				<i class="el-icon-d-arrow-right"></i>
			</div>
            <ul>
                <li v-for="(ite, idx) in item.children"
                    :key="idx"
                    :class="menuActive == index+'-'+idx?'active':''"
                    @click.stop="menuItem(item,ite,index,idx)">
                    {{ ite.meta.name }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            menu: [],
            menuActive: ''
        };
    },
    mounted () {

        let menu = JSON.parse(JSON.stringify(this.$router.options.routes[2]));
        menu.children.forEach(item => item.show = false);
        this.menu = menu


    },
    methods: {
        menuItem (item, ite, index, idx) {
            console.log(index, idx);
            this.menuActive = index + '-' + idx;
            this.$router.push('/personalCenter/' + item.path + '/' + ite.path)
            window.scrollTo({ top: 0, behavior: "smooth" });
            // scrollTo(100,0)
        }
    }
};
</script>

<style lang="scss">
.menu {
    .block {
        &.show {
            height: 61px;
            overflow: hidden;
        }

        .tit {
			height: 60px;
			line-height: 60px;
            background-color: #2899df;
            color: #ffffff;
            text-align: center;
            font-size: 20px;
            white-space: nowrap;
			border-bottom: 1px solid #F1F1F1;
			cursor: pointer;
			position: relative;
			&:hover{
				background-color: #347CAF;
			}
			i{
				position: absolute;
				right: 10px;
				top: 50%;
				transform: translateY(-50%) rotate(90deg);
			}
        }
        ul {
            list-style: none;
            text-align: center;
            padding-left: 0;
            margin: 0;
            background-color: #f1f1f1;
            li {
                border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                padding: 10px 0;
                white-space: nowrap;
                cursor: pointer;
                &:hover {
                    background: #43b5e7;
                    color: #f60;
                }
                &.active {
                    background: #43b5e7;
                    color: #fff;
                }
            }
        }
    }
}
</style>